<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <dev-model-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></dev-model-form>
  </j-modal>
</template>

<script>

  import DevModelForm from './DevModelForm'
  export default {
    name: 'DevModelModal',
    components: {
      DevModelForm
    },
    data () {
      return {
        title: '',
        width: 1000,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback (id = '') {
        this.$emit('ok', id);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>